import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

<meta name="viewport" content="width=device-width, user-scalable=no" />

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);